"use client";

import React from "react";

import { MultiSelect } from "@/components/fields/multi-select";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { useEventUpdates } from "@/pages/events/features/notifications/event-updates-context";

const followerTypes = [
  {
    id: "artist",
    label: "Artist Followers",
    description: "Notify followers of the artists performing",
  },
  {
    id: "venue",
    label: "Venue Followers",
    description: "Notify followers of the venue hosting the event",
  },
];

export function FollowerGroupSelectionModal() {
  const {
    isFollowerModalOpen,
    closeFollowerModal,
    selectedFollowerTypes,
    toggleFollowerType,
    sendEventUpdates,
    artists,
    venue,
  } = useEventUpdates();
  const [regions, setRegions] = React.useState<string[] | undefined>(undefined);

  const handleSendEventNotification = () => {
    console.log("YOOOO", selectedFollowerTypes);
    if (selectedFollowerTypes.length > 0) {
      sendEventUpdates("event_added_v2", {
        followerTypes: selectedFollowerTypes,
        venueId: selectedFollowerTypes.includes("venue") ? venue : undefined,
        artistIds: selectedFollowerTypes.includes("artist")
          ? artists.map((a) => a.id)
          : undefined,
        regions,
      });
    }
  };

  const handleCloseModal = () => {
    closeFollowerModal();
    setRegions(undefined);
  };

  return (
    <Dialog
      open={isFollowerModalOpen}
      onOpenChange={(open) => !open && handleCloseModal()}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Select Follower Types</DialogTitle>
          <DialogDescription>
            Choose which follower groups you want to notify about the new event.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {followerTypes.map((followerType) => (
            <div key={followerType.id} className="flex items-start space-x-3">
              <Checkbox
                id={followerType.id}
                checked={selectedFollowerTypes.includes(followerType.id)}
                onCheckedChange={() => toggleFollowerType(followerType.id)}
                className="mt-1"
              />
              <div className="space-y-1">
                <Label
                  htmlFor={followerType.id}
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  {followerType.label}
                </Label>
                <p className="text-xs text-muted-foreground">
                  {followerType.description}
                </p>
              </div>
            </div>
          ))}
          <div className="flex flex-col space-y-2 text-foreground w-full">
            <div className="text-sm">MoEngage Region Mapping</div>
            <MultiSelect
              options={[
                { label: "Attica", value: "Attica" },
                { label: "Thessaloniki", value: "Thessaloniki" },
                { label: "București", value: "București" },
                { label: "North Holland", value: "North Holland" },
                { label: "South Holland", value: "South Holland" },
                { label: "Cluj County", value: "Cluj County" },
                {
                  label: "Central Macedonia",
                  value: "Central Macedonia",
                },
                { label: "Achaea", value: "Achaea" },
                { label: "Ilfov", value: "Ilfov" },
                { label: "Utrecht", value: "Utrecht" },
                { label: "North Brabant", value: "North Brabant" },
                { label: "Prahova", value: "Prahova" },
                { label: "Iași County", value: "Iași County" },
                { label: "Timiș County", value: "Timiș County" },
                { label: "Brașov County", value: "Brașov County" },
                { label: "Gelderland", value: "Gelderland" },
                { label: "Constanța County", value: "Constanța County" },
                {
                  label: "Heraklion Regional Unit",
                  value: "Heraklion Regional Unit",
                },
                { label: "Nomós Larísis", value: "Nomós Larísis" },
                { label: "Bihor County", value: "Bihor County" },
                { label: "Overijssel", value: "Overijssel" },
                { label: "Limburg", value: "Limburg" },
                { label: "Flevoland", value: "Flevoland" },
                { label: "Nicosia", value: "Nicosia" },
                { label: "Sibiu County", value: "Sibiu County" },
                { label: "Ioannina", value: "Ioannina" },
                { label: "Magnesia", value: "Magnesia" },
                { label: "Dolj", value: "Dolj" },
                { label: "Chania", value: "Chania" },
                { label: "Euboea", value: "Euboea" },
                { label: "Groningen", value: "Groningen" },
                { label: "Arges", value: "Arges" },
                { label: "Dâmbovița County", value: "Dâmbovița County" },
                { label: "Buzău County", value: "Buzău County" },
                { label: "Galați County", value: "Galați County" },
                { label: "Dodecanese", value: "Dodecanese" },
                { label: "Corinthia", value: "Corinthia" },
                { label: "Arad County", value: "Arad County" },
                { label: "Friesland", value: "Friesland" },
                { label: "Nomós Kerkýras", value: "Nomós Kerkýras" },
                { label: "Nomós Kykládon", value: "Nomós Kykládon" },
                { label: "Nomós Voiotías", value: "Nomós Voiotías" },
                { label: "Messenia", value: "Messenia" },
                { label: "Kozani", value: "Kozani" },
                { label: "Bacău County", value: "Bacău County" },
                { label: "Mureș County", value: "Mureș County" },
                { label: "Vâlcea County", value: "Vâlcea County" },
                {
                  label: "Limassol District",
                  value: "Limassol District",
                },
                { label: "Sérres", value: "Sérres" },
                { label: "Rethymno", value: "Rethymno" },
                { label: "Suceava", value: "Suceava" },
                { label: "Hunedoara County", value: "Hunedoara County" },
                { label: "Kavala", value: "Kavala" },
                {
                  label: "North Rhine-Westphalia",
                  value: "North Rhine-Westphalia",
                },
                { label: "Pella", value: "Pella" },
                { label: "West Greece", value: "West Greece" },
                { label: "Arcadia", value: "Arcadia" },
                { label: "Xanthi", value: "Xanthi" },
                { label: "Nomós Rodópis", value: "Nomós Rodópis" },
                { label: "Nomós Kardhítsas", value: "Nomós Kardhítsas" },
                { label: "Nomós Kilkís", value: "Nomós Kilkís" },
                { label: "Teleorman County", value: "Teleorman County" },
                { label: "Călărași County", value: "Călărași County" },
                { label: "Crete", value: "Crete" },
                { label: "Gorj County", value: "Gorj County" },
                { label: "Chalkidikí", value: "Chalkidikí" },
                { label: "Laconia", value: "Laconia" },
                { label: "Chios", value: "Chios" },
                { label: "Thessaly", value: "Thessaly" },
                { label: "Brăila County", value: "Brăila County" },
                { label: "Ialomița County", value: "Ialomița County" },
                { label: "Peloponnese", value: "Peloponnese" },
              ]}
              selected={regions ?? []}
              onChange={(v) => {
                setRegions(v);
              }}
              placeholder="Select or type MoE regions..."
            />
          </div>
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={closeFollowerModal}>
            Cancel
          </Button>
          <Button
            onClick={handleSendEventNotification}
            disabled={selectedFollowerTypes.length === 0}
          >
            Send Notification ({selectedFollowerTypes.length})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
